import React from 'react';
import { Link } from 'react-router-dom';
import { clients } from '../data/mock';
import { ArrowUpRight } from 'lucide-react';

export default function Clients({ showAll = false }) {
  const items = showAll ? clients : clients;
  const looped = [...items, ...items];

  return (
    <section id="clients" className="relative py-20 sm:py-24 bg-[#faf6ef] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-12 sm:mb-14">
          <p className="text-[#b8842a] tracking-[0.28em] text-[11px] font-semibold uppercase mb-5">
            Trusted relationships
          </p>
          <h2 className="font-serif text-[#0a1b35] font-medium text-[30px] sm:text-[38px] lg:text-[48px] leading-[1.08] tracking-tight">
            Selected clients &amp;{' '}
            <span className="italic text-[#b8842a]">institutional partners.</span>
          </h2>
          <p className="mt-5 text-[#0a1b35]/70 text-[15px] lg:text-[16px] leading-relaxed">
            We have had the privilege of partnering with leading enterprises, public
            institutions, and international development organizations.
          </p>
        </div>
      </div>

      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 sm:w-32 bg-gradient-to-r from-[#faf6ef] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 sm:w-32 bg-gradient-to-l from-[#faf6ef] to-transparent z-10 pointer-events-none" />

        <div className="flex gap-3 animate-marquee whitespace-nowrap py-4">
          {looped.map((c, i) => (
            <div
              key={`${c.name}-${i}`}
              className="flex-shrink-0 px-6 sm:px-7 py-4 sm:py-5 bg-white border border-[#0a1b35]/8 rounded-2xl hover:border-[#b8842a]/45 hover:shadow-xl hover:shadow-[#0a1b35]/5 transition-all duration-300 min-w-[240px] sm:min-w-[260px]"
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#0a1b35] to-[#1a3a6b] flex items-center justify-center text-[#e8b863] font-serif font-medium text-[16px] flex-shrink-0">
                  {c.name.charAt(0)}
                </div>
                <p className="text-[#0a1b35] font-semibold text-[14px] sm:text-[14.5px] tracking-tight">{c.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-10 mt-12 sm:mt-14 text-center">
        <Link
          to="/clients"
          className="inline-flex items-center gap-2 text-[#0a1b35] font-semibold text-[14px] tracking-wide border-b-2 border-[#b8842a] pb-1 hover:text-[#b8842a] transition-colors"
        >
          View Client &amp; Experience Page
          <ArrowUpRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
